// extracted by mini-css-extract-plugin
export var alertIcon = "_pm-0";